import { findRouteConfig } from './find-route-config';
import { matchPathAndRoute } from './match-path-and-route';
import type { RouteConfig } from './types';

export function getRouteConfigByPath(currentPath: string): RouteConfig | undefined {
  return findRouteConfig((route) => {
    if (!route.path) {
      return false;
    }

    return matchPathAndRoute(currentPath, route.path);
  });
}
